import { ReflectiveInjector, Inject, Injectable } from "@angular/core";
import { RequestOptions, Headers } from "@angular/http";
import { user } from "@rx/security";
import { RequestHeaders } from "@rx/http";
import { RxStorage } from "@rx/storage"
import { RxSpinner } from "@rx/view";
import { AuthorizeApi } from "@rx/security";
import { requestCollection, Uri } from './request-uri';
import { ApplicationPage } from "@rx/core";
import { ActivatedRoute, Router } from '@angular/router';
@Injectable()
export class ApplicationRequestHeaders implements RequestHeaders {
    storage: RxStorage;
    headers: Headers;
    requestCount: number = 0;
    constructor(@Inject(RxSpinner) private spinner: RxSpinner) {
        let injector: any = ReflectiveInjector.resolveAndCreate([RxStorage]);
        this.storage = injector.get(RxStorage);
        this.headers = new Headers();
        this.headers.append('Accept', 'application/json, */*; q=0.01');

    }
    get(url: string, requestMethod?: string, authorizeApi?: AuthorizeApi): RequestOptions {
        if (requestCollection.length == 0)
            this.spinner.show();
        requestCollection.push(0);
        console.log(`request in ${this.requestCount}`);
        this.requestCount++;
        var auth = this.storage.local.get('auth');
        var session = this.storage.local.get("lastAccessTime");
        this.headers.delete("Authorization");
        this.headers.delete("x-application-module");
        this.headers.delete("x-child-module-name");
        this.headers.delete("x-record");
        this.headers.delete("x-session");
        if (auth != null && auth != undefined)
            this.headers.append("Authorization", auth);
        if (session != null && session != undefined)
            this.headers.append("x-session", session);
        if (authorizeApi && authorizeApi.api) {
            if (authorizeApi.applicationModuleId)
                this.headers.append("x-application-module", authorizeApi.applicationModuleId.toString());
            if (authorizeApi.childModuleName) {
                this.headers.append("x-application-module", ApplicationPage.get("applicationModuleId"));
                this.headers.append("x-child-module-name", authorizeApi.childModuleName);
            }
            if (authorizeApi.mainRecordId)
                this.headers.append("x-record", authorizeApi.mainRecordId.toString())
        }
        let opts: RequestOptions = new RequestOptions({ headers: this.headers });
        return opts;
    }
}
